import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { AvpFilterExpressionData } from './avp-filter-expression-common';

/**
 * Data payload for rendering AVP filter expressions after deletion.
 */
export type AvpFilterExpressionDeleteData = AvpFilterExpressionData & {
	/**
	 * The identifiers of the filter expressions that were deleted.
	 */
	expressionIds: string[];
};

/**
 * Properties for the AVP filter expression deletion command.
 *
 * @extends CommandProperties
 */
export interface AvpFilterExpressionDeleteCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the filter expression deletion request.
	 */
	key: string;
	/**
	 * The data payload containing the identifiers and updated filter expression tree.
	 */
	data: AvpFilterExpressionDeleteData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to render AVP filter expressions after deletion.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to render the updated AVP filter expression tree after deletion.
 */
export const AvpFilterExpressionDeleteCommand: CommandConstructor<
	AvpFilterExpressionDeleteCommandProperties,
	SerializableValue
> = createCommand<AvpFilterExpressionDeleteCommandProperties>(
	'avp-filter-expression-delete-command',
);
